import { useTranslation } from "react-i18next";

import BannerMessage, {
  BANNER_MESSAGE_STATUSES
} from "@/components/BannerMessage/BannerMessage";
import Dialog from "@/components/Dialog/Dialog";
import { DialogWidth } from "@/components/Dialog/types/enums";
import { ReassignVehicleData, useMediaQueries } from "@/shared";
import DialogActions from "@/shared/components/buttons/DialogActions";
import { Typography } from "@mui/material";

import { useSingleInfoLine } from "../shared/useSingleInfoLine";

interface AccessibleImeiDialogProps {
  dialogData: ReassignVehicleData | null;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const AccessibleImeiDialog = ({
  dialogData,
  isOpen,
  onClose,
  onSubmit
}: AccessibleImeiDialogProps) => {
  const { t } = useTranslation();
  const { toMd } = useMediaQueries();

  const { singleInfoLine } = useSingleInfoLine();

  const { company, imei, vehicleNumber } = dialogData || {};

  return (
    <Dialog
      title={t("Dialog##add vehicle imei in use accessible##title")}
      description={t("Dialog##add vehicle imei in use accessible##description")}
      extendToMaxWidth={toMd}
      isTitleSeparator
      isActionsSeparator
      open={isOpen}
      close={onClose}
      submit={onSubmit}
      width={toMd ? undefined : DialogWidth.MinWidth}
      actions={
        <DialogActions
          onClose={onClose}
          isLoading={false}
          isreadyToConfirm
          confirmationButtonText={t("Button##continue")}
          confirmationButtonTestId="confirm-accessible-imei-button"
          cancelButtonText={t("Button##back")}
          cancelButtonTestId="close-confirm-accessible-imei"
        />
      }
    >
      <BannerMessage
        data-testid="activate-vehicle-banner"
        status={BANNER_MESSAGE_STATUSES.Info}
        description={
          <>
            <Typography
              variant="body3Medium"
              component="p"
              sx={{ marginBottom: "4px" }}
            >
              {t("Dialog##add vehicle imei in use accessible##vehicle imei", {
                imeiValue: imei
              })}
            </Typography>
            {singleInfoLine(t("Dialog##vrn"), vehicleNumber)}
            {singleInfoLine(t("Dialog##company"), company)}
          </>
        }
      />
    </Dialog>
  );
};

export default AccessibleImeiDialog;
